export class MathService {
  static parseNumber(value: string | number | null): number {
    if (!value) {
      return 0
    }

    return typeof value === 'number' ? value : Number(value.replace(',', '.')) || 0
  }
}
